import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  dialogRef;
  constructor(public dialog: MatDialog,private router:Router) { }

  openDialog(options){
    try{
      this.dialogRef.closeAll();
    }catch(err){

    }
    return new Promise((resolve,reject)=>{
      this.dialogRef = this.dialog.open(AlertDialogComponent,{
        width: '30rem',
        height: '22rem',
        panelClass:'alert-dialog-wrapper',
        data:options
      });
      this.dialogRef.afterClosed().subscribe((data)=>{
        console.log(data)
        //this.router.navigate(['/', 'terms-condition']);
        window.location.reload();
        try{
          if(data){
            resolve(data);
          }
          else{
            reject(null);
          }
        }
        catch(err){
          reject(null);
        }
      })
    })
  }
}
